// Nome para exibir a partir dos claims do ID token.
// Keycloak manda preferred_username (o telefone) e given_name; o Cognito manda
// name, email e phone_number — e cognito:username, que e um UUID interno e nunca
// deve aparecer na tela. Sem este fallback a Home dizia "Olá, 👋".
export function displayName(profile: Record<string, unknown> | undefined | null): string {
  const p = (profile ?? {}) as Record<string, unknown>;
  const pick = (...keys: string[]) =>
    keys.map((k) => p[k]).find((v) => typeof v === "string" && v.trim()) as string | undefined;
  return pick("given_name", "name", "email", "preferred_username", "phone_number") ?? "";
}

export function username(profile: Record<string, unknown> | undefined | null): string {
  const p = (profile ?? {}) as Record<string, unknown>;
  const v = p["preferred_username"] ?? p["cognito:username"] ?? p["username"];
  return typeof v === "string" ? v : "";
}
